import React from 'react'

export const courierWithInstantPickup = (company) => {
    let status = false;

    switch (company) {
        case "GOJEK":
        case "gojek":
        case "GO-JEK":
        case "Go-Jek":
        case "go-jek":
        case "GRAB":
        case "Grab":
        case "grab":
        case "jne":
        case "anteraja":
        case "rara":
        case "jet":
        case "rpx":
        case "jdl":
        case "sicepat":
        case "deliveree":
        case "jnt":
        case "paxel":
        case "idexpress":
        case "mrspeedy":
        case "alfatrex":
        case "lalamove":
        case "ninja":
        case "tiki":
        case "lion":
        case "sap":
            status = true;
            break;
        default:
    }
    return status
};

export const allDayPickupCourier = company => {
    let status = false;

    switch (company) {
        case "GOJEK":
        case "gojek":
        case "GO-JEK":
        case "Go-Jek":
        case "go-jek":
        case "GRAB":
        case "RARA":
        case "rara":
        case "Grab":
        case "grab":
        case "deliveree":
        case "mrspeedy":
        case "lalamove":
            status = true;
            break;
        default:
    }
    return status
}

export const courierWithMultipleItems = c => {
    let s = false;

    switch (c) {
        case 'jne':
        case 'jet':
        case 'tiki':
        case 'ninja':
        case 'jnt':
        case 'sicepat':
        case 'wahana':
        case 'pos':
        case 'anteraja':
        case 'lion':
        case "paxel":
        case "sap":
        case "rpx":
            s = true;
            break;
        default:
            s = false;
    }
    return s
};

export const courierWithNotes = c => {
    let s = false;

    switch (c) {
        case "GOJEK":
        case "gojek":
        case "GO-JEK":
        case "Go-Jek":
        case "go-jek":
        case "GRAB":
        case "Grab":
        case "grab":
        case "deliveree":
        case "rara":
        case "mrspeedy":
            s = true;
            break;
        default:
            s = false;
    }
    return s
};

export const courierWithCOD = c => {
    let s = false;

    switch (c) {
        case "jet":
        case "sicepat":
        case "sap":
            s = true;
            break;
        default:
            s = false;
    }
    return s
};

export const courierWithCoordinates = c => {
    let s = false;

    switch (c) {
        case "GOJEK":
        case "gojek":
        case "GO-JEK":
        case "Go-Jek":
        case "go-jek":
        case "GRAB":
        case "Grab":
        case "grab":
        case "rara":
        case "deliveree":
        case "paxel":
        case "mrspeedy":
        case "lalamove":
            s = true;
            break;
        default:
            s = false;
    }
    return s
};

export const normalizeCourierServices = (c, s) => {
    let description, sn, cc, tv;

    let company = !c ? "a" : c.toUpperCase();
    let service = !s ? "a" : s.toUpperCase();

    let newCompanyName;
    if(company === "GOJEK") {
        newCompanyName = "Gojek";
        switch (service) {
            case "INSTANT":
                sn = 'instant';
                cc = 'instant';
                tv = 'Instant';
                description = 'Langsung sampai';
                break;
            case "SAMEDAY":
            case "SAME DAY":
            case "SAME_DAY":
                sn = "same_day";
                cc = "sameDay";
                tv = "Same Day";
                description = 'Sampai di hari yang sama';
                break;
            default:
        }
    } else if(company === "GRAB") {
        newCompanyName = "Grab";
        switch (service) {
            case "INSTANT":
                sn = 'instant';
                cc = 'instant';
                tv = 'Instant';
                description = 'Langsung sampai';
                break;
            case "SAMEDAY":
            case "SAME DAY":
            case "SAME_DAY":
                sn = "same_day";
                cc = "sameDay";
                tv = 'Same Day';
                description = 'Sampai di hari yang sama';
                break;
            case "CAR EXPRESS":
            case "CAR_EXPRESS":
            case "CAREXPRESS":
            case "INSTANTCAR":
            case "INSTANT_CAR":
                sn = 'instant_car';
                cc = 'instantCar';
                tv = 'Instant Car';
                description = 'Langsung sampai pakai mobil';
                break;
            default:
        }
    } else if(company === "MRSPEEDY") {
        newCompanyName = "Mr Speedy";
        switch (service) {
            case "INSTANT_CAR":
            case "INSTANTCAR":
                sn = 'instant_car';
                cc = 'instantCar';
                tv = 'Instant Car';
                description = 'Pengiriman dengan mobil';
                break;
            case "INSTANT_BIKE":
            case "INSTANTBIKE":
                sn = 'instant_bike';
                cc = 'instantBike';
                tv = 'Instant Bike';
                description = 'Pengiriman dengan motor';
                break;
            default:
        }
    } else if(company === "RARA") {
        newCompanyName = "Rara Delivery";
        switch (service) {
            case "INSTANT":
                sn = 'instant';
                cc = 'instant';
                tv = 'Instant';
                description = 'Pengiriman instant dengan motor';
                break;
            default:
        }
    } else if(company === "JDL") {
        newCompanyName = "JDL Express";
        switch (service) {
            case "REG":
                sn = 'reg';
                cc = 'reg';
                tv = 'Regular';
                description = 'Pengiriman reguler';
                break;
            default:
        }
    } else if(company === "JNE") {
        newCompanyName = "JNE";
        switch (service) {
            case "REG":
            case "REGULER":
                sn = "reg";
                cc = "reg";
                tv = 'REG';
                description = 'Layanan reguler';
                break;
            case "YES":
                sn = "yes";
                cc = "yes";
                tv = 'YES';
                description = 'Yakin esok sampai';
                break;
            case "OKE":
                sn = "oke";
                cc = "oke";
                tv = 'OKE';
                description = 'Ongkos kirim ekonomis';
                break;
            case "CTC":
                sn = "ctc";
                cc = "ctc";
                tv = 'CTC';
                description = 'Pengiriman city to city';
                break;
            case "CTCSPS":
                sn = "ctcsps";
                cc = "ctcsps";
                tv = 'CTCSPS';
                description = 'Pengiriman city to city super speed';
                break;
            case "JTR":
                sn = "jtr";
                cc = "jtr";
                tv = 'JTR';
                description = 'Layanan trucking JNE';
                break;
            case "JTR_250":
            case "JTR250":
                sn = "jtr_250";
                cc = "jtr250";
                tv = 'JTR>250';
                description = 'Layanan truck untuk motor lebih dari 250cc';
                break;
            case "JTR_150_250":
            case "JTR150250":
                sn = "jtr_150_250";
                cc = "jtr150250";
                tv = 'JTR250';
                description = 'Layanan truck untuk motor dari 150 sampai 250cc';
                break;
            case "JTR_150":
            case "JTR150":
                sn = "jtr_150";
                cc = "jtr150";
                tv = 'JTR<150';
                description = 'Layanan truck untuk motor kurang dari 150cc';
                break;
            case "SS":
            case "SPS":
                sn = "sps";
                cc = "sps";
                tv = 'SPS';
                description = 'Super speed';
                break;
            case "CTCYES":
            case "CTCYES19":
                sn = "ctcyes";
                cc = "ctcyes";
                tv = 'CTCYES';
                description = 'City to city yakin esok sampai';
                break;
            case "PELIKAN":
                sn = "pelikan";
                cc = "pelikan";
                tv = 'Pelikan';
                description = 'Layanan untuk mengirim dokumen khusus';
                break;
            case "POPBOX":
                sn = "popbox";
                cc = "popbox";
                tv = 'PopBox';
                description = 'Layanan untuk mengirim dengan PopBox';
                break;
            default:
        }
    } else if(company === "TIKI") {
        newCompanyName = "TIKI";
        switch (service) {
            case "ECO":
            case "EKO":
                sn = "eko";
                cc = "eko";
                tv = 'EKO';
                description = 'Layanan ekonomis';
                break;
            case "REG":
                sn = "reg";
                cc = "reg";
                tv = 'REG';
                description = 'Layanan reguler';
                break;
            case "ONS":
                sn = "ons";
                cc = "ons";
                tv = 'ONS';
                description = 'One night service';
                break;
            case "SDS":
                sn = "sds";
                cc = "sds";
                tv = 'SDS';
                description = 'Same day service';
                break;
            case "TRC":
                sn = "trc";
                cc = "trc";
                tv = 'TRC';
                description = 'Tiki trucking service';
                break;
            case "T15":
                sn = "t15";
                cc = "t15";
                tv = 'T15';
                description = 'Tiki trucking for bike below 150cc';
                break;
            case "T25":
                sn = "t25";
                cc = "t25";
                tv = 'T25';
                description = 'Tiki trucking for bike below 250cc';
                break;
            case "T60":
                sn = "t60";
                cc = "t60";
                tv = 'T60';
                description = 'Tiki trucking for bike below 600cc';
                break;
            default:
        }
    } else if (company === 'SAP') {
        newCompanyName = "SAP";
        switch (service) {
            case "REG":
            case "UDRREG":
                sn = "reg";
                cc = "reg";
                tv = "REG";
                description = 'Regular Service';
                break;
            case "ODS":
            case "UDRONS":
                sn = "ods";
                cc = "ods";
                tv = "ODS";
                description = 'One Day Service';
                break;
            case "SDS":  
            case "UDRSDS":          
                sn = "sds";
                cc = "sds";
                tv = "SDS";
                description = 'Same Day Service';
                break;
            case "CARGO DARAT":     
            case "DRGREG":
                sn = "cargo";
                cc = "cargo";
                tv = "Cargo";
                description = 'Cargo service';
                break;
            default:
                sn = service.toLowerCase();
                cc = service.toLowerCase();
                tv = service
                description = "-";
                break;
        }
    } else if(company === "ALFATREX") {
        newCompanyName = "Alfatrex";
        switch (service) {
            case "RGS_DTD":
            case "RGSDTD":
            case "RGS":
                sn = "rgs_dtd";
                cc = "rgsDtd";
                tv = 'RGS Door to Door';
                description = 'Regular service door to door';
                break;
            case "ECS_DTD":
            case "ECSDTD":
            case "ECS":
                sn = "ecs_dtd";
                cc = "ecsDtd";
                tv = 'ECS Door to Door';
                description = 'Economical door to door';
                break;
            case "SDS_DTD":
            case "SDSDTD":
            case "SDS":
                sn = "sds_dtd";
                cc = "sdsDtd";
                tv = 'SDS Door to Door';
                description = 'Same day door to door';
                break;
            case "NDS_DTD":
            case "NDSDTD":
            case "NDS":
                sn = "nds_dtd";
                cc = "ndsDtd";
                tv = 'NDS Door to Door';
                description = 'Next day door to door';
                break;
            default:
        }
    } else if(company === "SICEPAT") {
        newCompanyName = "SiCepat";
        switch (service) {
            case "REG":
                sn = "reg";
                cc = "reg";
                tv = 'REG';
                description = 'Layanan reguler';
                break;
            case "CARGO":
                sn = "cargo";
                cc = "cargo";
                tv = 'Cargo';
                description = 'Layanan kargo';
                break;
            case "GOKIL":
                sn = "gokil";
                cc = "gokil";
                tv = 'Gokil';
                description = 'Layanan gokil (Kargo Kilat)';
                break;
            case "BEST":
                sn = "best";
                cc = "best";
                tv = 'BEST';
                description = 'Besok sampai tujuan';
                break;
            case "SDS":
                sn = "sds";
                cc = "sds";
                tv = 'SDS';
                description = 'Same Day Service';
                break;
            default:
        }
    } else if(company === "JET") {
        newCompanyName = "Jet Express";
        switch (service) {
            case "CRG":
                sn = "crg";
                cc = "crg";
                tv = 'CRG';
                description = 'Layanan kargo';
                break;
            case "PRI":
            case "PRIORITY":
                sn = "pri";
                cc = "pri";
                tv = 'PRI';
                description = 'Layanan prioritas';
                break;
            case "REG":
            case "REGULER":
                sn = "reg";
                cc = "reg";
                tv = 'REG';
                description = 'Layanan reguler';
                break;
            case "FX":
                sn = "fx";
                cc = "fx";
                tv = 'FX';
                description = 'Fashion Express';
                break;
            case "XPS":
                sn = "xps";
                cc = "xps";
                tv = 'XPS';
                description = 'Layanan express';
                break;
            default:
        }
    } else if(company === "JNT" || company === 'J&T') {
        newCompanyName = "J&T";
        switch (service) {
            case "EZ":
                sn = "ez";
                cc = "ez";
                tv = 'EZ';
                description = 'Layanan reguler';
                break;
            case "JSD":
                sn = "jsd";
                cc = "jsd";
                tv = 'JSD';
                description = 'Same day delivery';
                break;
            default:
        }
    } else if(company === "IDEXPRESS") {
        newCompanyName = "IDExpress";
        switch (service) {
            case "REG":
                sn = "reg";
                cc = "reg";
                tv = 'Reguler';
                description = 'Layanan pengiriman standard';
                break;
            case "SMD":
                sn = "smd";
                cc = "smd";
                tv = 'Same Day';
                description = 'Layanan same day';
                break;
            case "IDTRUCK":
                sn = "idtruck";
                cc = "idtruck";
                tv = 'ID Truck';
                description = 'Layanan trucking';
                break;
            default:
        }
    } else if(company === "NINJA") {
        newCompanyName = "Ninja Express";
        switch (service) {
            case "NEXTDAY":
            case "NEXT_DAY":
                sn = "next_day";
                cc = "nextDay";
                tv = 'Next Day';
                description = 'Layanan next day';
                break;
            case "STANDARD":
                sn = "standard";
                cc = "standard";
                tv = 'Standard';
                description = 'Layanan standard';
                break;
            default:
        }
    } else if(company === "RPX") {
        newCompanyName = "RPX";
        switch (service) {
            case "SDP":
                sn = "sdp";
                cc = "sdp";
                tv = "SDP";
                description = 'Same Day Package';
                break;
            case "MDP":
                sn = "mdp";
                cc = "mdp";
                tv = "MDP";
                description = 'Mid Day Package';
                break;
            case "NDP":
                sn = "ndp";
                cc = "ndp";
                tv = "NDP";
                description = 'Next Day Package';
                break;
            case "RGP":
                sn = "rgp";
                cc = "rgp";
                tv = "RGP";
                description = 'Regular Package';
                break;
            case "PAS":
                sn = "pas";
                cc = "pas";
                tv = "PAS";
                description = 'Paket Ambil Suka-suka';
                break;
            case "ECP":
                sn = "ecp";
                cc = "ecp";
                tv = "ECP";
                description = 'Economy Delivery (ECP)';
                break;
            case "HWP":
                sn = "hwp";
                cc = "hwp";
                tv = "HWP";
                description = 'Heavy Weight Delivery (HWP)';
                break;
            default:
        }
    } else if(company === "ANTERAJA") {
        newCompanyName = "AnterAja";
        switch (service) {
            case "REG":
            case "REGULAR":
                sn = "reg";
                cc = "reg";
                tv = 'Reguler';
                description = 'Layanan reguler (2 - 3 hari sampai)';
                break;
            case "SD":
            case "SAME_DAY":
            case "SAMEDAY":
                sn = "same_day";
                cc = "sameDay";
                tv = 'Same Day';
                description = 'Layanan sampai di hari yang sama';
                break;
            case "ND":
            case "NEXT_DAY":
            case "NEXTDAY": 
                sn = "next_day";
                cc = "nextDay";
                tv = 'Next Day';
                description = 'Layanan sampai di keesokan harinya';
                break;
            default:
        }
    } else if (company === 'LION') {
        newCompanyName = "Lion Parcel";
        switch (service) {
            case "REGPACK":
            case "REG_PACK":
                sn = "reg_pack";
                cc = "regPack";
                tv = "Reg Pack";
                description = 'Layanan standard';
                break;
            case "ONEPACK":
            case "ONE_PACK":
                sn = "one_pack";
                cc = "onePack";
                tv = "One Pack";
                description = 'Layanan besok sampai';
                break;
            case "LANDPACK":
            case "LAND_PACK":
                sn = "land_pack";
                cc = "landPack";
                tv = "Land Pack";
                description = 'Pengiriman menggunakan kereta api';
                break;
            default:
        }
    } else if (company === 'WAHANA') {
        newCompanyName = "Wahana";
        switch (service) {
            case "NORMAL":
                sn = "normal";
                cc = "normal";
                tv = "Normal";
                description = 'Layanan standard';
                break;
            default:
        }
    } else if (company === 'PAXEL') {
        newCompanyName = "Paxel";
        switch (service) {
            case "SMALL":
                sn = "small";
                cc = "small";
                tv = "Small";
                description = 'Layanan standard';
                break;
            case "MEDIUM":
                sn = "medium";
                cc = "medium";
                tv = "Medium";
                description = 'Layanan standard';
                break;
            case "LARGE":
                sn = "large";
                cc = "large";
                tv = "Large";
                description = 'Layanan standard';
                break;
            default:
        }
    } else if (company === 'LALAMOVE') {
        newCompanyName = "Lalamove";
        switch (service) {
            case "MOTORCYCLE":
                sn = "motorcycle";
                cc = "motorcycle";
                tv = "Motorcycle";
                description = 'Pengiriman dengan motor';
                break;
            case "MPV":
                sn = "mpv";
                cc = "mpv";
                tv = "MPV";
                description = 'Layanan dengan mobil';
                break;
            case "VAN":
                sn = "van";
                cc = "van";
                tv = "Van";
                description = 'Pengiriman dengan van';
                break;
            case "TRUCK175":
                sn = "truck175";
                cc = "truck175";
                tv = "Truck";
                description = 'Pengiriman dengan truk';
                break;
            default:
        }
    } else if (company === 'POS') {
        newCompanyName = "Pos Indonesia";
        switch (service) {
            case "KILAT_KHUSUS":
            case "KILATKHUSUS":
                sn = "kilat_khusus";
                cc = "kilatKhusus";
                tv = "Kilat Khusus";
                description = 'Layanan kilat khusus';
                break;
            case "SAME_DAY":
            case "SAMEDAY":
                sn = "same_day";
                cc = "sameDay";
                tv = "Same Day";
                description = 'Layanan sampai di hari yang sama';
                break;
            case "Q9_BARANG":
            case "Q9_SAME_DAY":
            case "Q9SAMEDAY":
                sn = "q9_same_day";
                cc = "q9SameDay";
                tv = "Q9 Sameday Service";
                description = 'Max 9 jam sampai';
                break;
            case "NEXT_DAY":
            case "NEXTDAY":
                sn = "next_day";
                cc = "nextDay";
                tv = "Next Day";
                description = 'Layanan paket besok sampai';
                break;
            case "JUMBO_EKONOMI":
            case "JUMBOEKONOMI":
                sn = "jumbo_ekonomi";
                cc = "jumboEkonomi";
                tv = "Jumbo Ekonomi";
                description = 'Layanan dengan tarif tingkat berat pertama mulai dari 3kg - 30kg';
                break;
            default:
        }
    } else if(company === "DELIVEREE") {
        newCompanyName = "Deliveree";
        switch (service) {
            case "ECONOMY":
                sn = "economy";
                cc = "economy";
                tv = "Economy";
                break;
            case "VAN":
                sn = "van";
                cc = "van";
                tv = "Van";
                break;
            case "SMALLPICKUP":
            case "SMALL_PICKUP":
                sn = "small_pickup";
                cc = "smallPickup";
                tv = "Small Pickup";
                break;
            case "SMALL_BOX":
            case "SMALLBOX":
                sn = "small_box";
                cc = "smallBox";
                tv = "Small Box";
                break;
            case "ENGKEL_PICKUP":
            case "ENGKELPICKUP":
                sn = "engkel_pickup";
                cc = "engkelPickup";
                tv = "Engkel Pickup";
                break;
            case "ENGKEL_BOX":
            case "ENGKELBOX":
                sn = "engkel_box";
                cc = "engkelBox";
                tv = "Engkel Box";
                break;
            case "CDD_BOX":
            case "CDDBOX":
                sn = "cdd_box";
                cc = "cddBox";
                tv = "CDD Box";
                break;
            case "CDD_PICKUP":
            case "CDDPICKUP":
                sn = "cdd_pickup";
                cc = "cddPickup";
                tv = "CDD Pickup";
                break;
            case "FUSO_LIGHT":
            case "FUSOLIGHT":
                sn = "fuso_light";
                cc = "fusoLight";
                tv = "Fuso Light";
                break;
            case "FUSO_HEAVY":
            case "FUSOHEAVY":
                sn = "fuso_heavy";
                cc = "fusoHeavy";
                tv = "Fuso Heavy";
                break;
            case "CDE_FROZEN":
            case "CDEFROZEN":
                sn = "cde_frozen";
                cc = "cdeFrozen";
                tv = "CDE Frozen";
                break;
            case "CDE_CHEMICAL":
            case "CDECHEMICAL":
                sn = "cde_chemical";
                cc = "cdeChemical";
                tv = "CDE Chemical ";
                break;
            case "CDE_FLAMMABLE":
            case "CDEFLAMMABLE":
                sn = "cde_flammable";
                cc = "cdeFlammable";
                tv = "CDE Flammable";
                break;
            case "TRONTON_BOX":
            case "TRONTONBOX":
                sn = "tronton_box";
                cc = "trontonBox";
                tv = "Tronton Box";
                break;
            case "TRONTON_WING_BOX":
            case "TRONTONWINGBOX":
                sn = "tronton_wing_box";
                cc = "trontonWingBox";
                tv = "Tronton WingBox";
                break;
            default:
                sn = "-";
                cc = "-";
                tv = "-";
        }
    } else {
        description="-";
        newCompanyName = company;
        sn = "-";
        cc = "-";
        tv = service;
    }

    return {
        typeSnakeFormat:sn,
        typeCamelCaseFormat:cc,
        typeView:tv,
        companyName: newCompanyName,
        description,
    }
};
